<script>
import { campaignComputed, prospectComputed } from '@state/helpers';

export default {
  components: {},
  props: {
    templates: {
      type: Array,
      required: true,
      default: () => [],
    },
    isEmailMsg: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...campaignComputed,
    ...prospectComputed,
  },
  mounted() {},
  methods: {
    isTemplateSelected(msg) {
      return (
        this.selectedCampaign && msg && this.selectedCampaign._id === msg._id
      );
    },
    selectCampaignTemplate(msg) {
      this.$emit('select-campaign-template', msg);
    },
  },
};
</script>

<template>
  <div class="message-template-options">
    <label>Select a Prebuilt Template</label>
    <div class="row template-options-row">
      <div class="col">
        <div class="template-options-wrapper">
          <div
            v-for="(msg, i) in templates"
            :class="['template-option', { selected: isTemplateSelected(msg) }]"
            :key="i"
            @click="selectCampaignTemplate(msg)"
          >
            <h4 v-if="isEmailMsg">{{ msg.emailSubject }}</h4>
            <p>{{ isEmailMsg ? msg.emailBody : msg.smsMessage }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.message-template-options {
  .template-options-row {
    margin-bottom: 2.5rem;
    overflow-x: scroll;
    width: 135%;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .template-options-wrapper {
    display: flex;
    overflow-x: scroll;
    padding: 0 0 0.7rem 0.3rem;
    width: 127%;

    .template-option {
      border: 2px solid $color-light-gray-nineteen;
      border-radius: $base-border-radius-md;
      margin-right: 0.8rem;
      padding: 0.8rem 1.2rem;
      width: 18.6rem;

      &:hover,
      &.selected {
        box-shadow: 0 0.2rem 0.5rem rgba($color-black-wo-rgb, 0.1);
        cursor: pointer;
        transform: scale(1.01);
      }

      &.selected {
        border: 2px solid $color-primary;
        cursor: default;
        transform: unset;
      }

      h4,
      p {
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
